export default __webpack_public_path__ + "static/media/7_Dinamica_exposicion_y_actividades.cea92f29.mp3";